// import { useMutation } from "@tanstack/react-query";
// import { UploadFileService } from "../../../../../services/file/UploadFileService";

// const imageExts = [
//   "image/jpeg",
//   "image/png",
//   "image/gif",
//   "image/bmp",
//   "image/webp",
//   "image/svg+xml",
//   "image/tiff",
//   "image/x-icon",
//   "image/vnd.microsoft.icon",
//   "image/vnd.wap.wbmp",
//   "image/heic",
//   "image/heif",
//   "image/jxr",
//   "image/avif",
//   "image/apng",
//   "image/x-png",
// ];

export const useViagsUpload = () => {
  const mapUploadResponse = (resFiles: any[] = []) => {
    return resFiles.reduce((files, file) => {
      if (file?.url) return [...files, file];
      if (file?.response) {
        const { uid, name, type, size } = file;
        let url = "";
        if (Array.isArray(file.response.data)) {
          url = file.response.data[0];
        } else {
          url = file.response.data;
        }
        return [...files, { uid, name, type, url, size }];
      }
      return files;
    }, []);
  };

  return { mapUploadResponse };
};
